export default function BaseAddress() {
  // set up the base address
  let baseAddress = window.location.protocol + '//' + window.location.hostname;
  // we need to cater for a port number in the location. This will probably only come into play for local development.
  if (!!window.location.port !== false) {
    baseAddress += ':' + window.location.port;
  }

  return baseAddress;
}
